import {Button} from '@mui/material';
import {EmptySearchState as EmptySearchStateGlobal} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {ExamResultsTaggingEnum} from 'main/analytics/gaTagsEnum';
import {useExamsListEmptyState} from './hooks/useExamsListEmptyState';
import {ExamsListEmptyStateProps} from './types';

const {clearFilters} = translations['pt-br'].commons;
const {
	noResults: {scheduleExam},
	emptyState,
} = translations['pt-br'].privateFlow.examResults;

export const ExamsListEmptyState = ({clearFilter, isWaitingResult}: ExamsListEmptyStateProps) => {
	const {isMobile, hasFilterActive, showBookingButton, emptyDescription, handleGoToBookingExam} =
		useExamsListEmptyState(!!isWaitingResult);

	return (
		<EmptySearchStateGlobal
			title={emptyState.title}
			description={emptyDescription()}
			noMarginImage={!isMobile}
			customMaxWidthCard={'100%'}
			customMargin="0"
			customJustifyContent="center"
			data-tag-id={
				isWaitingResult
					? ExamResultsTaggingEnum.VISUALIZOU_EMPTY_STATE_AGUARDANDO_LIBERACAO
					: ExamResultsTaggingEnum.VISUALIZOU_EMPTY_STATE_LIBERADOS
			}
			sx={{justifyContent: 'center', textAlign: isMobile ? 'center' : 'left'}}>
			{showBookingButton ? (
				<Button
					size="large"
					onClick={handleGoToBookingExam}
					data-tag-id={ExamResultsTaggingEnum.CLICK_AGENDAR_EXAME_EMPTY_STATE}>
					{scheduleExam}
				</Button>
			) : null}

			{hasFilterActive ? (
				<Button
					size="large"
					variant="outlined"
					onClick={clearFilter}
					data-tag-id={
						isWaitingResult
							? ExamResultsTaggingEnum.CLICK_LIMPAR_FILTRO_RESULTADO_DE_EXAMES_AGUARDANDO_LIBERACAO
							: ExamResultsTaggingEnum.CLICK_LIMPAR_FILTRO_RESULTADO_DE_EXAMES_LIBERADOS
					}>
					{clearFilters}
				</Button>
			) : null}
		</EmptySearchStateGlobal>
	);
};
